import styled from 'styled-components';

export const Container = styled.ul`
  margin-top: 5px;

  li {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #444;

    & + li {
      margin-top: 15px;
    }
  }
`;

export const FileInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1;
  border-left: 5px solid ${props => props.theme.primaryColor};
  padding: 5px;
  margin-bottom: 1rem;
  background: ${props => props.theme.lightGrey};

  button {
    border: 0;
    background: transparent;
    color: #e83f5b;
    margin-left: 5px;
    cursor: pointer;
  }

  div {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: baseline;
    margin: 0 5px;

    span {
      font-size: 12px;
      color: #999;
      margin: 5px;
    }
  }
`;
